import React from 'react';
import { IKIOSKModel, IKioskOtherServiceMenu, IkioskMenuIds } from '../../../../models/kioskModel2';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { appointmentsRequest, language_Request, menuTypeAction, setNewpatientLanguageSelection } from '../../../../store/actions';
import { Ilanguages } from '../../../../models/utilitiesModel';

const LanguageSelection: React.FC = () => {
    const { t } = useTranslation("translations");
    const dispatch = useDispatch();
    const language: any = useSelector((state) => (state?.kioskReducer2 as IKIOSKModel)?.language);
    const patientId: boolean = useSelector((state) => (state?.kioskReducer2 as IKIOSKModel)?.patientId || 0);
    const selectedPage: string = useSelector((state) => (state.kioskReducer2 as IKIOSKModel)?.selectedPage);
    const newPatientBranchdata: IKioskOtherServiceMenu = useSelector((state) => (state.kioskReducer2 as IKIOSKModel)?.isNewpatientRegistration || undefined);
    
    console.log("language===>", language,newPatientBranchdata,selectedPage);

    if ([Ilanguages.ARB, Ilanguages.ENG].includes(language)) {
        dispatch(menuTypeAction(IkioskMenuIds.APPOINMENTS));
        dispatch(appointmentsRequest(IkioskMenuIds.APPOINMENTS));
    }

    const handleLanguage=(lang)=>{
        return (newPatientBranchdata && selectedPage === IkioskMenuIds.NEWPATIENTLANGUAGE) ? dispatch(setNewpatientLanguageSelection(lang,IkioskMenuIds.NEWPATIENT)) : dispatch(language_Request(lang, patientId)) 
    }

    const check=()=>{
        if(selectedPage === IkioskMenuIds.NEWPATIENTLANGUAGE){
            return newPatientBranchdata ? true : false;
        }
        else if(selectedPage === IkioskMenuIds.LANGUAGE){
            return (![Ilanguages.ARB, Ilanguages.ENG].includes(language)) ? true : false
        }
        else return false;
    }

    
    return (
        <div className='align-items-center d-flex flex-column mt-15 lang_select'>
            {
            check() && 
                <>
                    <span>{t("kiosktranslation.plzselectLang-Ar")}</span>
                    <span>{t("kiosktranslation.plzselectLang")}</span>
                    <div className='d-flex gap26 mt-4'>
                        <button type='button' className='Kiosk_button Kiosk_button_eng' onClick={() =>handleLanguage(Ilanguages.ENG)}>{t("kiosktranslation.eng")}</button>
                        <button type='button' className='Kiosk_button Kiosk_button_ar' onClick={() =>handleLanguage(Ilanguages.ARB)}>{t("kiosktranslation.arb")}</button>
                    </div>
                </>
            }
            {!newPatientBranchdata && selectedPage === IkioskMenuIds.NEWPATIENTLANGUAGE && <h1>{t("kiosktranslation.newpatientNotavailbe")}</h1>}
        </div>
    )
}
export default React.memo(LanguageSelection);